<template>
  <div class="d-flex flex-row">
    <div
      class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
      id="kt_profile_aside"
    >
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-end">
            <KTDropdown2></KTDropdown2>
          </div>
          <div class="d-flex align-items-center">
            <div
              class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div
                class="symbol-label"
                :style="{
                  backgroundImage: `url(media/users/blank.png)`
                }"
              ></div>
              <i class="symbol-badge bg-success"></i>
            </div>
            <div>
              <a
                class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                >{{ datosUsuario.nombreUsuario }}</a
              >
              <div class="text-muted">{{datosUsuario.nombreRol}}</div>
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-9">
             <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2 d-none">Rol</span>
              <span class="text-muted">{{
                datosUsuario.nombreInstitucion
              }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2 d-none">Correo Electrónico:</span>
              <a class="text-muted text-hover-primary">{{
                datosUsuario.nombrePuesto
              }}</a>
            </div>
            <div class="d-flexwwwwwww align-items-center justify-content-between mb-2 d-none">
              <span class="font-weight-bold mr-2">Telefono:</span>
              <span class="text-muted">{{
                datosUsuario.phone
              }}</span>
            </div>
           
          </div>
          <!--end::Contact-->
          <!--begin::Nav-->
          <div
            class="navi navi-bold navi-hover navi-active navi-link-rounded"
            role="tablist"
          >
            <div class="navi-item mb-2 d-none">
              <a
                class="navi-link py-4 active"
                @click="setActiveTab"
                style="cursor:pointer"
                data-tab="0"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Design/Layers.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">Profile Overview</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4 active"
                @click="setActiveTab"
                style="cursor:pointer"
                data-tab="1"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">Informaci&oacute;n Personal</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4"
                @click="setActiveTab"
                style="cursor:pointer"
                data-tab="3"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                      src="media/svg/icons/Communication/Shield-user.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">Actualizar Contrese&ntilde;a</span>
                <span class="navi-label">
                  <span
                    class="label label-light-danger label-rounded font-weight-bold d-none"
                    >5</span
                  >
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8">
      <b-tabs class="hide-tabs" v-model="tabIndex">
        <b-tab>
          <KTProfileOverview></KTProfileOverview>
        </b-tab>

        <b-tab active>
          <KTPersonalInformation></KTPersonalInformation>
        </b-tab>

        <b-tab>
          <KTAccountInformation></KTAccountInformation>
        </b-tab>

        <b-tab>
          <KTChangePassword></KTChangePassword>
        </b-tab>

        <b-tab>
          <KTEmailSettings></KTEmailSettings>
        </b-tab>
      </b-tabs>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTDropdown2 from "@/view/pages/perfil/dropdown/Dropdown2";
import KTProfileOverview from "@/view/pages/perfil/profile-comp-1/ProfileOverview";
import KTPersonalInformation from "@/view/pages/perfil/profile-comp/PersonalInformation";
import KTAccountInformation from "@/view/pages/perfil/profile-comp/AccountInformation";
import KTChangePassword from "@/view/pages/perfil/profile-comp/ChangePassword";
import KTEmailSettings from "@/view/pages/perfil/profile-comp/EmailSettings";

import { GET_CURRENT_USER } from "@/core/services/store/auth.module";

export default {
  name: "custom-page",
  components: {
    KTDropdown2,
    KTProfileOverview,
    KTPersonalInformation,
    KTAccountInformation,
    KTChangePassword,
    KTEmailSettings
  },
  data() {
    return {
      tabIndex: 0,
      datosUsuario:[],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Profile 1" }]);
  },
  methods: {

    /**
     * Obtener información del usuario
     */
    async getUserInfo(){
      await this.$store
        .dispatch(GET_CURRENT_USER)
        .then(res => {
          //console.log(res)
          if(res.status===200){
            this.datosUsuario = this.$store.state.auth.currentUser;
          }
        })
        .catch(()=>{
          this.$router.push({ name: "login" });
        })
    },

    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    }
  },

  created(){
    this.getUserInfo();
  },
  computed: {
    ...mapGetters(["currentUser"]),

    getFullName() {
      return (
        this.currentUser.nombreUsuario/* +
        " " +
        this.currentUser.nombreUsuario*/
      );
    },

    //...mapGetters(["currentUserPersonalInfo"]),

    /*getFullName() {
      return (
        this.currentUserPersonalInfo.name +
        " " +
        this.currentUserPersonalInfo.surname
      );
    }*/
  }
};
</script>
